import { put, takeLatest, all } from "redux-saga/effects"
import { appName } from "../constants"

/**
 * Constants
 **/
export const moduleName = "selector"
const prefix = `${appName}/${moduleName}`

const SET_SELECTOR_VALUE_CALL = `${prefix}/SET_SELECTOR_VALUE_CALL`
const SET_SELECTOR_VALUE = `${prefix}/SET_SELECTOR_VALUE`

/**
 * Reducer
 **/
const initialState = {
  value: 25
}

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case SET_SELECTOR_VALUE:
      return {
        ...state,
        value: value
      }

    default:
      return state
  }
}

/**
 * Selectors
 **/

/**
 * Action Creators
 **/
export function setSelectorValue(value) {
  return {
    type: SET_SELECTOR_VALUE_CALL,
    payload: { value }
  }
}

/**
 * Sagas
 **/
function* setSelectorValueSaga({ payload: { value } }) {
  yield put({
    type: SET_SELECTOR_VALUE,
    value: +value
  })
}

export function* saga() {
  yield all([takeLatest(SET_SELECTOR_VALUE_CALL, setSelectorValueSaga)])
}
